
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2021-02-22-material-ui-and-tailwindcss",
      function () {
        return require("private-next-pages/blogs/2021-02-22-material-ui-and-tailwindcss/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2021-02-22-material-ui-and-tailwindcss"])
      });
    }
  